export default function Footer() {
  return (
    <footer className="w-full bg-foreground-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <a href="/" className="inline-block mb-4 cursor-pointer">
              <span className="font-heading text-2xl font-bold text-white">
                YOYBUY<span className="text-primary-400">.</span>BOND
              </span>
            </a>
            <p className="text-foreground-400 text-sm leading-relaxed mb-5">
              Ваш надёжный гид по покупкам из Китая через систему YOYBUY Spreadsheet.
              Экономьте до 40% с прозрачными ценами и комиссиями.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white text-sm mb-4 uppercase tracking-wider">
              Категории
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-white text-sm transition-colors cursor-pointer">
                  Обувь
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-white text-sm transition-colors cursor-pointer">
                  Худи / Свитера
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-white text-sm transition-colors cursor-pointer">
                  Футболки
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-white text-sm transition-colors cursor-pointer">
                  Куртки
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-white text-sm transition-colors cursor-pointer">
                  Аксессуары
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-semibold text-white text-sm mb-4 uppercase tracking-wider">
              Ресурсы
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="/blog/yoybuy-spreadsheet-guide" className="text-foreground-400 hover:text-white text-sm transition-colors cursor-pointer">
                  Гид по YOYBUY Spreadsheet
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-white text-sm transition-colors cursor-pointer">
                  Платформа Kaspreadsheet
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-white text-sm transition-colors cursor-pointer">
                  yoybuy sheet
                </a>
              </li>
            </ul>
          </div>

          {/* Trust */}
          <div>
            <h4 className="font-semibold text-white text-sm mb-4 uppercase tracking-wider">
              Безопасность
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-foreground-400 text-sm">
                <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center text-primary-400"></i>
                Безопасные покупки
              </li>
              <li className="flex items-center gap-2 text-foreground-400 text-sm">
                <i className="ri-verified-badge-line w-4 h-4 flex items-center justify-center text-primary-400"></i>
                Проверенные агенты
              </li>
              <li className="flex items-center gap-2 text-foreground-400 text-sm">
                <i className="ri-customer-service-2-line w-4 h-4 flex items-center justify-center text-primary-400"></i>
                Поддержка 24/7
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-foreground-800">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} yoybuy.bond. Все права защищены.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-500 hover:text-white text-xs transition-colors cursor-pointer">
              Политика конфиденциальности
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-500 hover:text-white text-xs transition-colors cursor-pointer">
              Условия использования
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}